export default "__VITE_ASSET__1f346dc9__"